import User from '../interfaces/User';

const getUser = (id: string, users: User[]) =>
    users.find((user: User) => user._id === id);

export default getUser;
